import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';
import { AppEnvConfig } from '../../../../app.env.config';
import { TermsAndConditionsServiceConfig } from './terms-and-conditions.service.config';
@Injectable({
    providedIn: 'root'
})

export class TermsAndConditionsService {
    private configEnv: any;
    url: string;

    constructor(
        private termsAndConditionsServiceConfig: TermsAndConditionsServiceConfig,
        private httpClient: HttpClient,
        private config: AppEnvConfig
    ) {
        this.configEnv = this.termsAndConditionsServiceConfig.getEnvironment();
        this.configEnv.apiServerUrl = config.getEnv('apiServerUrl');
        this.configEnv.apiServerUrlAuth = config.getEnv('apiServerUrl');
    }

    private parse(url: string, params: string[] = []): string {
        let result: string = url;
        if (params.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            result = url.replace(/\{(\d+)\}/g, function (match: string, current: string): string {
                return params[parseInt(current, 10)] !== undefined ? params[parseInt(current, 10)] : '';
            });
        }
        return result;
    }

    /**
     * @description fetches the terms and conditions document for the service
     * @param serviceTypeId number
     * @returns 
     */
    public getTermsAndConditionsByService(serviceTypeId: number): Observable<any> {
        const url = this.parse(this.configEnv.apiServerUrl + this.configEnv.apiUrl.termsAndConditionsByService, [serviceTypeId.toString()]);
        return this.httpClient.get(url).pipe(map(response => {
            try {
                return response;
            } catch (e) {
                return response;
            }
        }));
    }

    /**
     * @description saves the terms and conditions for the provided terms and conditions Id
     * @param termsAndConditionsId number
     * @returns 
     */
    public acceptServiceTermsAndConditions(termsAndConditionsId: number): Observable<any> {
        const url = this.parse(this.configEnv.apiServerUrl + this.configEnv.apiUrl.consentTermsAndConditions, [termsAndConditionsId.toString()]);
        return this.httpClient.post(url, {}).pipe(map(response => {
            try {
                return response;
            } catch (e) {
                return response;
            }
        }));
    }

}
